import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Music2, Radio, Disc3, Sparkles } from 'lucide-react';

const iconMap = {
  Music2: Music2,
  Radio: Radio,
  Disc3: Disc3,
};

export const AboutFeatureModal = ({ feature, open, onClose }) => {
  if (!feature) return null;

  const IconComponent = iconMap[feature.icon] || Music2;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-gradient-to-b from-black via-orange-950/20 to-black border-orange-500/30 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <div className="flex items-center justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-orange-500/30 to-green-500/30 flex items-center justify-center">
              <IconComponent className="w-10 h-10 text-orange-400" />
            </div>
          </div>
          <DialogTitle className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-green-400 text-center mb-4">
            {feature.title}
          </DialogTitle>
        </DialogHeader>

        {/* Feature Description */}
        <div className="space-y-6">
          <div className="border-t border-orange-500/20 pt-6">
            <div className="flex items-center space-x-2 mb-4">
              <Sparkles className="w-5 h-5 text-green-400" />
              <p className="text-gray-400 text-sm font-semibold">About This Feature</p>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed whitespace-pre-line">
              {feature.description}
            </p>
          </div>

          {/* Decorative gradient separator */}
          <div className="flex items-center justify-center py-4">
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
          </div>

          {/* Additional visual elements */}
          <div className="bg-black/50 backdrop-blur-sm border border-green-500/20 rounded-lg p-6">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-green-500/20 to-orange-500/20 flex items-center justify-center flex-shrink-0">
                <IconComponent className="w-6 h-6 text-green-400" />
              </div>
              <div>
                <p className="text-gray-400 text-sm mb-2">Part of DharmaR's Vision</p>
                <p className="text-gray-300 text-sm leading-relaxed">
                  This is one of our core pillars in creating transformative psychedelic experiences through music and community.
                </p>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
